export default {
  "flex-shrink": "_flex-shrink_1e80hj",
  "z-index": "_z-index_1e80hj",
  "ml-12": "_ml-12_1e80hj",
  "quick-actions-trigger": "_quick-actions-trigger_1e80hj",
  "active": "_active_1e80hj",
  "dropdown-menu": "_dropdown-menu_1e80hj"
};